import type { SVGProps } from 'react'

const SvgMoon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' {...props}>
    <g mask='url(#mask0_4_5)'>
      <path
        d='M12 1.2C12.2571 1.2 12.5108 1.25183 12.7594 1.35468C13.0074 1.45742 13.2343 1.60252 13.4396 1.79062L15.4453 3.77168H18.1717C18.7373 3.77174 19.2208 3.97357 19.6236 4.37636C20.0264 4.77916 20.2283 5.26271 20.2283 5.82832V8.55468L22.2094 10.5603C22.3975 10.7657 22.5426 10.9926 22.6453 11.2406C22.7482 11.4892 22.8 11.7429 22.8 12C22.8 12.2571 22.7482 12.5108 22.6453 12.7594C22.5426 13.0074 22.3975 13.2343 22.2094 13.4396L20.6941 14.9725C19.673 15.3756 18.5637 15.6 17.4 15.6C12.4294 15.6 8.39999 11.5706 8.39999 6.6C8.40005 5.43682 8.62124 4.32799 9.02226 3.30937L10.5603 1.79062C10.7657 1.60252 10.9926 1.45742 11.2406 1.35468C11.4892 1.25183 11.7429 1.2 12 1.2Z'
        fill='#FEC412'
      />
      <path
        d='M7.09657 2.57288C7.27069 2.74712 7.22639 2.94726 7.09657 3.35947C6.77443 4.38239 6.6 5.47072 6.6 6.60004C6.6 12.5647 11.4353 17.4 17.4 17.4C18.5818 17.4 19.7182 17.2078 20.782 16.8558C21.1441 16.736 21.341 16.7156 21.399 16.7738C21.457 16.832 21.5593 17.0312 21.399 17.3143C19.5444 20.5889 16.032 22.8 12 22.8C6.03532 22.8 1.2 17.9647 1.2 12.0001C1.2 8.24219 3.11998 4.93417 6.03195 3.00004C6.51424 2.67971 6.92245 2.39865 7.09657 2.57288Z'
        fill='#B8C2CC'
      />
    </g>
  </svg>
)
export default SvgMoon
